import React from "react"
import { View } from "react-native"

export default function Gap({ size = 0, horizontal }) {
  const sizeProp = horizontal ? "width" : "height"

  return <View style={{ [sizeProp]: size }} />
}
